import "./SamacharSection.css";

function SamacharSection() {
  return (
    <div className="samachar-section">
      <div className="samachar-section__title-box">
        <h2 className="samachar-section__main-tittle">समाचार</h2>
      </div>
      {/*     <div className="suchana-section__suchana-box">
        <div className="suchana-section__suchana">
          <img
            src="assets"
            className="suchana-section__image"
            alt="image of news"
          />
          <h3 className="suchana-section__suchana-tittle">
            बार्षिक साधारण सभा सम्पन्न{" "}
          </h3>
        </div> 
      </div> */}
      <div className="samachar-section__temp-box">
        <h3>अहिले कुनै समाचार उपलब्द छैनन् </h3>
      </div>
    </div>
  );
}

export default SamacharSection;
